import {
  I_ApprovalReference,
  I_ApprovalRuleTemplateGroup,
  I_ApproverChain,
  I_ApprovalStatusTypesWithRules,
  I_ApprovalActionType,
} from "../interfaces";

const approvalReferenceBoilerplate: I_ApprovalReference = {
  TemplateGroups: [] as I_ApprovalRuleTemplateGroup[],
  ApproverChains: [] as I_ApproverChain[],
  ApprovalStatusTypesWithRules: [] as I_ApprovalStatusTypesWithRules[],
  ApprovalActionTypes: [] as I_ApprovalActionType[],
  Employees: []
};

export default approvalReferenceBoilerplate;
